export enum ZmUserStatus {
  SENT = "Sent",
  READY_TO_SEND = "Ready to send",
  IN_PROGRESS = "In progress",
}

export function formatZmUserStatus(status: string): string {
  const label = ZmUserStatus[status as keyof typeof ZmUserStatus];
  if (label) {
    return label;
  }

  if (Object.values(ZmUserStatus).includes(status as ZmUserStatus)) {
    return status;
  }

  return status;
}
